<lgv-loading-indicator *ngIf="isLoading$ | async"></lgv-loading-indicator>

<div class="container">

    <div class="row">
        <div class="col-12">
            <h3>Select a Client</h3>
            <p>Search for a client, or create a new client.</p>
            <div class="Vert-20"></div>
        </div>
    </div>

    <ng-container *ngIf="!(clientInfo$ | async)">
        <form [formGroup]="_form">
            <div class="row">
    
                <ng-container *ngIf="isSelectClientMode$ | async">
                    <div><b>Client Search</b></div>
                    <div class="Vert-10"></div>

                    <div class="col-12 displayValue" *ngIf="!!agentDTO">
                        <lus-client-search label="Client Name" [SelectedAgent]="currentAgent" [SelectedCompany]="currentCompany"
                            [SelectedOrganization]="currentOrganization"
                            (OnClientDTOSelected)="selectClient($event)"></lus-client-search>
                    </div>

                    <a (click)="onNewClientMode()" title="Create a new client"><fa-icon icon="plus"></fa-icon> New Client</a>
                </ng-container>
    
                <ng-container *ngIf="isNewClientMode$ | async">
                    <div><b>Add a New Client</b></div>
                    <div class="Vert-10"></div>

                    <mat-form-field appearance="outline" floatLabel="always" class="col-12">
                        <mat-label>First Name</mat-label>
                        <input type="text" matInput formControlName="firstName">
                    </mat-form-field>
                    <mat-form-field appearance="outline" floatLabel="always" class="col-12">
                        <mat-label>Last Name</mat-label>
                        <input type="text" matInput formControlName="lastName">
                    </mat-form-field>
                    <mat-form-field appearance="outline" floatLabel="always" class="col-12">
                        <mat-label>Email</mat-label>
                        <input type="text" matInput formControlName="email">
                    </mat-form-field>
                    <mat-form-field appearance="outline" floatLabel="always" class="col-12">
                        <mat-label>Phone</mat-label>
                        <input type="text" matInput matInputPhoneNumber maxlength="10" formControlName="phone">
                    </mat-form-field>

                    <a (click)="onSelectClientMode()" title="Return to select existing client"><fa-icon icon="arrow-left"></fa-icon> Back</a>
                    
                </ng-container>
    
            </div>
        </form>
    
    </ng-container>

    <div *ngIf="clientInfo$ | async as client">
        <div class="Vert-15"></div>
        <div>{{client.firstName}} {{client.lastName}} | {{client.email}}
            &nbsp;&nbsp;<a (click)="onClearClientSelection()" title="Close"><fa-icon icon="close"></fa-icon></a>
        </div>
        <div class="Vert-30"></div>
    </div>


    <div class="row">
        <div class="col-12" align="end">
            <button mat-button class="btn btn-primary float-end" (click)="onSubmit()" [disabled]="!(_form.valid) || (isLoading$ | async)">
                <span *ngIf="isNewClientMode$ | async">Save</span>
                <span *ngIf="!(isNewClientMode$ | async)">Select</span>
             </button>
            <button mat-stroked-button (click)="onCancel()" class="btn btn-secondary float-end"
                style="margin-right:10px;"> Cancel </button>
        </div>
    </div>

</div>
